import { GraphQLClient } from 'graphql-request';
import { RequestConfig } from 'node_modules/graphql-request/build/legacy/helpers/types';

import { getSdk } from '~/server/generated/contentful-graphql';

const CONTENTFUL_GRAPHQL_API = `https://graphql.contentful.com/content/v1/spaces/${process.env.CONTENTFUL_SPACE_ID}/environments/${process.env.CONTENTFUL_ENVIRONMENT}`;

type ContentfulConfig = {
  preview?: boolean | null | undefined;
  cache?: RequestCache;
  next?: NextFetchRequestConfig;
  requestConfig?: Omit<RequestConfig, 'cache' | 'next'>;
};

const nextFetch = fetch;

export const contentfulApi = (opts: ContentfulConfig = {}) =>
  getSdk(
    new GraphQLClient(CONTENTFUL_GRAPHQL_API, {
      fetch: nextFetch,
      headers: {
        Authorization: `Bearer ${opts.preview ? process.env.CONTENTFUL_CPA_TOKEN : process.env.CONTENTFUL_CDA_TOKEN}`,
      },
      errorPolicy: 'all',
      method: 'GET',
      jsonSerializer: {
        parse: JSON.parse,
        stringify: JSON.stringify,
      },

      cache: opts.cache,
      next: opts.next,

      ...opts.requestConfig,

      // TODO: consider adding middleware for error handling
      // responseMiddleware: (response) => {},
    }),
  );

export function flattenItems<T>(items: T[] | null | undefined): NonNullable<T>[] {
  return items?.flatMap((i) => i || []) || [];
}
